// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_acd_module_acd_routing_module_ts":"2b7a8b02207e4ce9","src_app_features_reportingdashboard_module_reporting-dashboard_routing_module_ts":"3c596d65dd6c1735","src_app_features_user-manager_user-manager-routing_module_ts":"6005cfd80153b7ca"}[chunkId] + ".js";
};